import React from 'react';
import Investor from './Investor';

const InvestorRoutes = {
	dashboard: {
		tag: 'investment_dashboard',
		path: '/investment/dashboard',
		auth: true,
		layout: 'investor',
		component: <Investor page="dashboard" />,
	},
	fund_type: {
		tag: 'investment_fund_type',
		path: '/investment/types/:investExpertiseTag',
		auth: true,
		layout: 'investor',
		component: <Investor page="fund_type" />,
	},
	fund: {
		tag: 'investment_fund',
		path: '/investment/types/:investExpertiseTag/fund/:id',
		auth: true,
		layout: 'investor',
		component: <Investor page="fund" />,
	},
	profile: {
		tag: 'investment_profile',
		path: '/investor/profile',
		auth: true,
		layout: 'investor',
		component: <Investor page="profile" />,
	},
};

export default InvestorRoutes;
